import { render, staticRenderFns } from "./sendinfo.vue?vue&type=template&id=8847f88e&scoped=true"
import script from "./sendinfo.vue?vue&type=script&lang=js"
export * from "./sendinfo.vue?vue&type=script&lang=js"
import style0 from "./sendinfo.vue?vue&type=style&index=0&id=8847f88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8847f88e",
  null
  
)

export default component.exports